'use client'

import { FAQ } from '~/components/shared/FAQ'

/**
 * Client boundary for the shared {@link FAQ} accordion on the (server-rendered)
 * topic hub page. `FAQ` uses hooks + analytics event handlers, so it must live
 * in a client component; this thin wrapper keeps `TopicHubContent` a server
 * component while still emitting the FAQ accordion UI.
 *
 * `disableSchema` is deliberate: the topic page passes the same `topic.faqs`
 * array to `WithCategoryStructuredData`, which owns the single FAQPage JSON-LD
 * entity (same pattern as the generators hub and GeneratorLayout). Without it,
 * `FAQ` emits its own `JsonLd<FAQPage>` and FAQ-bearing topic pages ship TWO
 * FAQPage blocks for the same questions (`r3563203606`, #596).
 * topic-hub-faq-single-schema.test.tsx pins this.
 *
 * @param {{ items: { question: string; answer: string }[] }} props - Hub FAQs.
 * @returns {JSX.Element} Accordion without its own schema markup.
 */
export function TopicHubFaq({
  items,
}: {
  items: { question: string; answer: string }[]
}): JSX.Element {
  return <FAQ items={items} type="single" title="" disableSchema={true} />
}
